import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export function showLoadingModal(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('showLoadingModal')) {
        return;
    }

    return function(title: string = ''): void {
        sendMessage('showLoadingModal', Maybe.just({ title }).map(JSON.stringify));
    };
}

export function clearLoadingModal(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('clearLoadingModal')) {
        return;
    }

    return function(): void {
        sendMessage('clearLoadingModal', Maybe.nothing<string>());
    };
}
